import {combineReducers} from 'redux';
import scheduler from '../utils/scheduler-reducer';
import userData from '../UserInfo/userInfo-reducer';

export default combineReducers({userData, scheduler});
